import { z } from "zod"

/* eslint-disable @typescript-eslint/no-explicit-any */
export enum EAdmissionStages {
      criteria_selection = 'criteria_selection',
      payment = 'payment',
      basic_details = 'basic_details',
      educational_details = 'educational_details',
      experience_professional = 'experience_professional',
      statement_purpose = 'statement_purpose',
      upload_documents = 'upload_documents'
}

export enum EPaymentStatus {
      "Application Saved" = 0,
      "Application Submitted" = 1,
      "Application Fee Remitted" = 2,
      "Under Review" = 3,
      "Verified And Forwarded By OOA" = 4,
      "Shortlisted For Online IITK Test" = 5,
      "Shortlisted For Department Interview" = 6,
      "Shortlisted By Department" = 7,
      "Shortlisted By Senate" = 8,
      "Selected" = 9,
      "Accepted" = 10,
      "Admitted" = 11,
      "Dropped" = 12,
      "Rejected" = 13,
      "Cancelled" = 14
}
export interface IAdmissionStages {
      title?: EAdmissionStages
      status?: 'wait' | 'process' | 'finish',
      icon?: any
      disabled?: boolean
      description?: string,
      content?: React.ReactNode,
      method?: 'put' | 'post' | 'delete',
      url: string,
      schema?: z.AnyZodObject,
      getUrl: string
      eventAction?: string
}
export interface IAdmissionStagesResponse {
      order: number,
      stage: EAdmissionStages
      status: number,
      optional: number
}
export type TAdmissionStages = {
      [key in EAdmissionStages]?: IAdmissionStages
}

export enum NavigationKey {
      NEXT = 'next',
      PREV = 'prev',
      SUBMIT = 'submit',
}

interface IPersonalDetails {
      id: number,
      userId: number,
      dob: string,
      gender: string,
      nationality: string,
      identityNumber: string,
      category: string,
      dap: boolean,
      ageGroup: string,
      parentName: string,
      linkedinProfile: string,
      knowAboutProgram: string,
      totalWorkExperience: number,
      highestQualification: string,
      cpi: number,
      studentTypeIds: [],
      academicMetricType: string,
      academicMetricValue: number,
      examType: string,
      score: number,
      year: number,
      createdAt: EpochTimeStamp,
      updatedAt: EpochTimeStamp,
}

interface IUserAddress {
      id: number,
      userId: number,
      address: string,
      pincode: string,
      city: string,
      district: string,
      state: string,
      country: string,
      addressType: string,
      createdAt: EpochTimeStamp,
      updatedAt: EpochTimeStamp,
}


export interface IBasicDetailsResponse {
      message: string
      data: { personal_deatils?: IPersonalDetails, user_address?: Array<IUserAddress> }
}

interface ISchoolEducation {
      createdAt: EpochTimeStamp,
      updatedAt: EpochTimeStamp,
      id: number,
      userId: number,
      class: string,
      year: number,
      totalMarks: number,
      marksObtained: number,
      percentage: number,
      cpi: number,
}

interface IDegree {
      id: number,
      userId: number,
      degree: string,
      discipline: string,
      universityName: string,
      instituteName: string,
      year: string,
      marks: string,
      degreeLevel: string
      createdAt: EpochTimeStamp,
      updatedAt: EpochTimeStamp,
}

interface IUserResearchPublication {
      createdAt: EpochTimeStamp,
      updatedAt: EpochTimeStamp,
      id: number,
      userId: number,
      title: string,
      authors: string,
      year: number,
      conference: string
}

export interface IEducationDetailsResponse {
      message: string
      data: { school_education?: Array<ISchoolEducation>, graduation?: IDegree, post_graduation?: Array<IDegree>, users_research_publication?: Array<IUserResearchPublication> }
}

export interface IEducational {
      school_education?: Array<ISchoolEducation>, graduation?: IDegree, post_graduation?: Array<IDegree>, users_research_publication?: Array<IUserResearchPublication>
}

export interface IExperienceProfessional {
      createdAt: EpochTimeStamp,
      updatedAt: EpochTimeStamp,
      id: number,
      userId: number,
      organization: string,
      designation: string,
      role: string,
      payPerAnnum: string,
      from: string,
      to: string,
      employmentStatus: string,
      organizationType: string,
      natureOfOccupation: string,
      occupationalField: string
}

export interface IExperienceProfessionalResponse {
      message: string
      data: { experience_professional?: Array<IExperienceProfessional> }
}

export interface IStatementPurpose {
      id: number,
      userId: number,
      statement: string,
      createdAt: EpochTimeStamp,
      updatedAt: EpochTimeStamp,
}

export interface IStatementPurposeResponse {
      message: string
      data: { statement_purpose?: IStatementPurpose }
}

interface IEligibilityCriteria {
      type: number,
      label: string,
      criteria: string,
      fieldName: string
      validation: IValidation
}

interface IValidation {
      max: number,
      min: number,
      required: boolean
}

interface IEligibilityCriteriaJson {
      eligibilityCriteria?: Array<IEligibilityCriteria>
}

interface IIEligibilityCriteriaData {
      id: number,
      programId: number
      eligibilityCriteriaJson: IEligibilityCriteriaJson
      createdAt: EpochTimeStamp
      updatedAt: EpochTimeStamp
}

export interface IEligibilityCriteriaResponse {
      message: string
      data: IIEligibilityCriteriaData

}


export interface IUploadDocumentsResponse {
      message: string
}

export type TAdmissionStageResponse = {
      [EAdmissionStages.criteria_selection]: IEligibilityCriteriaResponse;
      [EAdmissionStages.basic_details]: IBasicDetailsResponse;
      [EAdmissionStages.educational_details]: IEducationDetailsResponse;
      [EAdmissionStages.experience_professional]: IExperienceProfessionalResponse;
      [EAdmissionStages.statement_purpose]: IStatementPurposeResponse;
      [EAdmissionStages.upload_documents]: IUploadDocumentsResponse;
      [EAdmissionStages.payment]?: any;
}


export interface FileItem {
      uid?: string;
      id?: number;
      name?: string;
      fileName?: string;
      entityType?: "personalDetails" | "markSheet10" | "markSheet12" | "graduationCertificate" | "graduationMarksheet" | "resume" | "experienceLetter" | 'extra_document' | 'passportSizePhoto' | 'postGraduationCertificate' | 'postGraduationMarksheet';
      createdAt?: EpochTimeStamp;
      updatedAt?: EpochTimeStamp;
      fileMime?: string;
      fileSize?: number;
      fileUrl?: string;
      status?: number;
      userId?: number;
}

export type SOP = {
      statement_purpose: {
            statement: string;
      }
}

export type ApplicationReviewTabProps = {
      dataSource: {
            applicationNumber: string | undefined;
            userId: number;
      };
}

export type AcceptApplicationModalProps = {
      dataSource: {
            applicationNumber: string | undefined;
            programName: string | undefined;
      }
}

export type CartPaymentModalProps = {
      dataSource: {
            selectedItemsList: [];
            totalAmount: number;
      }
}

export enum EPaymentCategory {
      admission_application_fee = 'admission_application_fee',
      admission_module_fee = 'admission_module_fee',
      admission_seat_booking_fee = 'admission_seat_booking_fee',
}

export const PaymentCategoryUrlMap: Record<EPaymentCategory, string> = {
      [EPaymentCategory.admission_application_fee]: '/dashboard/application',
      [EPaymentCategory.admission_module_fee]: '/dashboard/moduleSelection',
      [EPaymentCategory.admission_seat_booking_fee]: '/dashboard/application',
};

